import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CustomAlert from "../../shared/CustemAlert";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

export default function Add({ increment, counter }) {
  const [title, setTitle] = useState(""); // useState hook
  const [order, setOrder] = useState(0); // useState hook
  const [error, setError] = useState(false);
  const [isAdded, SetIsAdded] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  // handle change event
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    setTitle(e.target.value); // set name to e.target.value (event)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/nazeegtype/",
          { title: title.trim(), order: order },
          {
            signal: controller.signal,
          }
        );
        SetIsAdded(true);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    postData();
    setTitle("");
    setOrder(0);
    setError(false);
  };
  // render

  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3 border  ">
          <div className="card-header">
            <h2>סוגי הנציגים</h2>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="title">סוג נציג</label>
                    <input
                      type="text"
                      name="title"
                      value={title}
                      onChange={handleChange}
                      className="form-control"
                      id="title"
                      placeholder="תקליד סוג נציג להוספה"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="order">סדר הנציג</label>
                    <input
                      type="number"
                      name="order"
                      value={order}
                      onChange={(e) => setOrder(e.target.value)}
                      className="form-control"
                      id="order"
                      placeholder="סדר התפקיד"
                    />
                  </div>
                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף סוג נציג חדש
                  </button>
                </form>
              </Col>
            </Row>

            {isAdded && (
              <CustomAlert
                setShow={SetIsAdded}
                alertHeader={title}
                alertBody="סוג הנציג נוסף בהצלחה"
              />
            )}
          </div>
        </div>
      </center>
    </div>
  );
}
